import Vue from "vue";
import VueRouter from "vue-router";
import Payment from "../views/Payment.vue";
import PayResult from "../views/PayResult.vue";
import Paid from "../views/Paid.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Payment",
    component: Payment,
  },
  {
    path: "/pay-result",
    name: "PayResult",
    component: PayResult,
  },
  {
    path: "/Paid",
    name: "Paid",
    component: Paid,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
